import { useContext } from "react";
import MainContainer from "../../../components/MainContainer";
import AppPageForTableList from "../../personal_evaluation/shared/AppPageForTableList";
import { useNavigate } from "react-router";
import React from "react";
import { hasPrivilege } from "../../../utils/privilege";
import { userDetailContext } from "../../../App";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../../components/reusable/NotificationBull";
import RubriqueFiltre from "./RubriqueFiltre";
import { headerGed } from "../../../data/modules/ged-header";

const RubriqueListe = () => {
  const contextData = useContext(userDetailContext);
  const { Toast, showToast } = useToast();
  const navigate = useNavigate();

  const handleClickCreate = () => {
    if (hasPrivilege(contextData.privileges, "Button_create_module")) {
      navigate("/rubrique/add/");
    } else {
      showToast(
        TYPE_NOTIFICATION.ERROR,
        "Vous n'avez pas l'autorisation de créer un rubrique"
      );
    }
  };

  return (
    <MainContainer {...headerGed}>
      <Toast />
      <AppPageForTableList
        title={"Liste des rubriques"}
        button_creer_title={"Creer"}
        handleClickBtnCreer={handleClickCreate}
        filter_component={<RubriqueFiltre />}
      />
    </MainContainer>
  );
};

export default RubriqueListe;
